import { UserStub } from "api/common/types/auth.types";
import { TDateISO } from "api/common/types/datetime.types";
import { valueof } from "api/common/utils/type.utils";

export const STATEMENT_OF_PROFICIENCY_VALUES = {
  SATISFACTORY: "satisfactory",
  SATISFACTORY_COMMENTS: "satisfactory_with_comments",
  UNSATISFACTORY: "unsatisfactory",
} as const;
export type StatementOfProficiencyValues =
  | valueof<typeof STATEMENT_OF_PROFICIENCY_VALUES>
  | "";

export const QUALITY_RATING_VALUES = {
  EXCELLENT: "Excellent",
  SUFFICIENT: "Sufficient",
  POOR: "Poor",
} as const;
export type QualityRating = valueof<typeof QUALITY_RATING_VALUES> | "";

export const SEVERITY_RATING_VALUES = {
  NONE: "None",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  EXCESSIVE: "Excessive",
} as const;
export type SeverityRating = valueof<typeof SEVERITY_RATING_VALUES> | "";

export const FEEDBACK_STATUS = {
  DRAFT: "draft",
  FINAL: "final",
} as const;
export type FeedbackStatus = valueof<typeof FEEDBACK_STATUS>;

/** Writable form fields shared by draft and finalize payloads */
export interface ProficiencyFeedbackFormFields {
  statementOfProficiency: StatementOfProficiencyValues;
  nvlapFollowUp: boolean;
  requestedNvlapFollowUp: boolean;
  potentialNonConformities: string;
  isResubmission: boolean;
  validationTeamTwoWeeks: boolean | null;
  validationTeamDays: number | null;
  missTds: boolean | null;
  missTdsEcrs: string;
  misinterpretPolicy: boolean | null;
  misinterpretedPolicies: string;
  performTests: boolean | null;
  performTestsEcrs: string;
  quality: QualityRating;
  discrepancies: SeverityRating;
  evidence: SeverityRating;
  clarification: SeverityRating;
  missingItems: SeverityRating;
  comments: string;
}

/** GET response — form fields + read-only/computed fields */
export interface ProficiencyFeedback extends ProficiencyFeedbackFormFields {
  id?: number;
  createdOn?: TDateISO;
  editedOn?: TDateISO;
  filledOutBy?: UserStub;
  productId: number;
  ecrTotal: number;
  ecrsAfterPp2: number;
  checkOutPackageTotal: number;
  niapRecordId: string;
  status: FeedbackStatus;
  pdfFileId: number | null;
}

export interface ProficiencyFeedbackPathParams {
  productId: number | string;
}
